import { RadioChangeEvent } from 'antd/lib/radio';
import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { useRegisteredRef } from 'react-register-nodes';

import { Radio } from '../../components';

interface Props {
    name: string;
    label?: ReactNode;
    options: any[];
}

export default ({ name, ...bag }: Props) => {
    const ref = useRegisteredRef(name);

    return (
        <Field name={name}>
            {({ field: { onChange, ...fieldBag }, form }: FieldProps<any>) => {
                const handleChange = (e: RadioChangeEvent) => {
                    form.setFieldValue(name, e.target.value);
                };

                return (
                    <div ref={ref}>
                        <Radio
                            error={form.errors[name]}
                            onChange={handleChange}
                            {...fieldBag}
                            {...bag}
                        />
                    </div>
                );
            }}
        </Field>
    );
};
